import { render, staticRenderFns } from "./CardCategories.vue?vue&type=template&id=6a4f2693&scoped=true&"
import script from "./CardCategories.vue?vue&type=script&lang=js&"
export * from "./CardCategories.vue?vue&type=script&lang=js&"
import style0 from "./CardCategories.vue?vue&type=style&index=0&id=6a4f2693&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4f2693",
  null
  
)

export default component.exports